(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    const initShowroomThumbnailAutoplay = () => {
    const scrollers = Array.from(document.querySelectorAll('[data-showroom-autoplay]')).filter((element) => !element.showroomAutoplayReady);
    if (!scrollers.length) return;

    const desktopViewport = window.matchMedia('(min-width: 1000px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplaySpeed = 32;

    scrollers.forEach((scroller) => {
      scroller.showroomAutoplayReady = true;

      let direction = 1;
      let paused = true;
      let previousFrameTime;
      let resumeTimeout;

      const canAutoplay = () => desktopViewport.matches && !reducedMotion.matches && scroller.scrollWidth > scroller.clientWidth;

      const animate = (time) => {
        if (!paused && canAutoplay()) {
          const elapsed = previousFrameTime ? Math.min(time - previousFrameTime, 50) : 0;
          const maxScroll = scroller.scrollWidth - scroller.clientWidth;
          let nextScroll = scroller.scrollLeft + direction * autoplaySpeed * elapsed / 1000;

          if (nextScroll >= maxScroll) {
            nextScroll = maxScroll;
            direction = -1;
          } else if (nextScroll <= 0) {
            nextScroll = 0;
            direction = 1;
          }

          scroller.scrollLeft = nextScroll;
        }

        previousFrameTime = time;
        window.requestAnimationFrame(animate);
      };

      const pause = () => {
        window.clearTimeout(resumeTimeout);
        paused = true;
      };

      const play = () => {
        paused = false;
      };

      const delayedPlay = () => {
        window.clearTimeout(resumeTimeout);
        resumeTimeout = window.setTimeout(play, 1200);
      };

      scroller.addEventListener('pointerenter', pause);
      scroller.addEventListener('pointerleave', play);
      scroller.addEventListener('focusin', pause);
      scroller.addEventListener('focusout', play);
      scroller.addEventListener('touchstart', pause, { passive: true });
      scroller.addEventListener('touchend', delayedPlay, { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          pause();
        } else {
          play();
        }
      });

      window.requestAnimationFrame(animate);
      window.setTimeout(play, 600);
    });
  };

  initShowroomThumbnailAutoplay();
  document.addEventListener('shopify:section:load', initShowroomThumbnailAutoplay);
  } catch(e) { console.error(e); }
})();

})();
